import { useMutation } from "react-query";
import resetpassword from "../services/resetPassword";

function useResetPasswordMutation() {
  return useMutation(["ResetPassword"], resetpassword);
}

export default useResetPasswordMutation;
